import { render, staticRenderFns } from "./newImgText.vue?vue&type=template&id=3eb95e4e&scoped=true&"
import script from "./newImgText.vue?vue&type=script&lang=ts&"
export * from "./newImgText.vue?vue&type=script&lang=ts&"
import style0 from "./newImgText.vue?vue&type=style&index=0&id=3eb95e4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb95e4e",
  null
  
)

export default component.exports